import { ActionType } from "_sirius/src/actions/action_types";

export const setIsExpanded = (isExpanded: boolean) => ({
  type: ActionType.SET_NAVIGATION_SIDEBAR_IS_EXPANDED as const,
  payload: { isExpanded },
});
